module.exports = __webpack_public_path__ + "static/media/teletava6.5c64fb2e.png";